const MESURE_PROTECTION_STATUS = {
  en_attente: "en_attente",
  en_cours: "en_cours",
  eteinte: "eteinte",
};

module.exports = { MESURE_PROTECTION_STATUS };
